(
    function (skyward, $, undefined)
    {
        skyward.studentapplication = skyward.studentapplication || {};
        "use strict";

        var init = function (selector)
        {
            $(selector + ' .studentapplicationtablerow').each(function ()
            {
                var stepRow = $(this);

                if (!stepRow.length)
                {
                    return;
                }

                var currentValues = stepRow.find('.studentApplicationCurrentValue');
                var updatedValues = stepRow.find('.studentApplicationUpdatedValue');
                if (currentValues.length && updatedValues.length)
                {
                    updatedValues.each(function (index)
                    {
                        var updatedValue = $(this);
                        var currentValue = currentValues.eq(index);
                        if (currentValue.length)
                        {
                            var updatedValueHeight = updatedValue.height();
                            var currentValueHeight = currentValue.height();
                            if (updatedValueHeight < currentValueHeight)
                            {
                                updatedValue.css('min-height', currentValueHeight);
                                updatedValue.css('top', currentValue.top());
                            }
                            else if (updatedValueHeight > currentValueHeight)
                            {
                                currentValue.css('min-height', updatedValueHeight);
                                currentValue.css('top', updatedValue.top());
                            }
                        }
                    });
                }
            });
        }

        skyward.studentapplication.approveStudentApplicationClick = function (approveFormButton)
        {
            approveFormButton = approveFormButton instanceof $ ? approveFormButton : $(approveFormButton);

            if (approveFormButton.hasClass('ui-disabled'))
            {
                return false;
            }

            var container = approveFormButton.parents('.contentArea');
            var dovSaveButton = container.find('.button.save');
            var dovCancelButton = container.find('.button.cancel');
            var saveCompleteCallback = function (e)
            {
                container.off('DOVSaveComplete DOVSaveValidationError', saveCompleteCallback);
                // Only run the approval process if it was the SaveComplete event that triggered the callback
                if (e.type === 'DOVSaveComplete')
                {
                    skyward.window.loadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/Enrollment/StudentApplication/Approve', null,
                    {
                        'Workflow.StudentApplicationID': $('#editStudentApplication_StudentApplicationStudentApplicationID').val(),
                        'Workflow.StudentApplicationID_securityhash': approveFormButton.data('studentapplicationid-securityhash')
                    });
                }
            };

            // Always save the screen
            dovSaveButton.addClass('dirty'); // Need to make DOV think we're dirty so it actually saves
            dovCancelButton.addClass('dirty'); // For consistency, dirty Cancel so it shows too
            saveStudentApplication(dovSaveButton, { "IsApproval": true });
            container.on('DOVSaveComplete DOVSaveValidationError', saveCompleteCallback);
        };

        var saveStudentApplication = function (button, postData)
        {
            var data = button.data();
            data.dataObjectViewerContainerId = 'editStudentApplication';
            data.id = $('#editStudentApplication_StudentApplicationStudentApplicationID').val();
            data.module = "Enrollment";
            data.object = 'StudentApplication';
            data.screen = "Details";
            data.tab = "General";
            data.saveAction = 'StudentApplicationSave';
            completeSaveStudentApplication(postData, button, data, saveStudentApplication);
        };

        var completeSaveStudentApplication = function (postData, button, data, clickFunc)
        {
            button.off('click.save');
            $.when(skyward.dataobjectviewer.save(data.dataObjectViewerContainerId, data.module, data.object, data.screen, data.id, null, data.saveAction, false, data.tab, false, false, postData)).done(function ()
            {
                button.on('click.save', function () { clickFunc(button, postData); });
            });
        };

        // Event handlers
        var events =
        {
            "approveStudentApplicationClick": skyward.studentapplication.approveStudentApplicationClick
        };
        skyward.events.registerEvents("studentapplication", events);
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);